var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13a8 8 0 0 1 7.996 7.75L20 21a1 1 0 0 1-1.993.117L18 21a6 6 0 0 0-11.996-.225L6 21a1 1 0 0 1-1.993.117L4 21a8 8 0 0 1 8-8zm0-10a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z",
    fill: "var(--theme-dark-accent)",
    className: "invert-light"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "var(--mono-white)",
    cx: 12,
    cy: 7,
    r: 2,
    className: "invert-dark"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-profile.8a418167879c3b804bdd69669c89129e.svg";